import React from 'react'
import logo from '../assets/logo.png'
import fb from '../assets/icons/fb.png'
import ig from '../assets/icons/ig.png'
import x from '../assets/icons/x.png'
import ln from '../assets/icons/in.png'
import yt from '../assets/icons/yt.png'
import { Link } from 'react-router-dom'
import { FaLocationDot } from "react-icons/fa6";
import { MdMail } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";

const Footer = () => {
    return (
        <footer className="bg-[#0058AE] text-white px-6 md:px-20 py-12">
            <div className="flex flex-col md:flex-row justify-between gap-10">

                {/* Company Info */}
                <div className='flex flex-col gap-4 max-w-[380px]'>
                    <div className='flex justify-center md:justify-start'>
                        <img src={logo} alt='eSparse Matrix Logo' className='w-[60px] h-[50px]' />
                    </div>
                    <p className='text-xl font-extrabold leading-snug'>
                        eSparse Matrix Solutions Pvt Ltd
                    </p>
                    <p className='text-base leading-relaxed'>
                        Esparse Matrix Solution Private Limited is a software development company based in India that serves clients globally. We focus on delivering innovative solutions to help clients grow.
                    </p>
                    <div className='flex gap-3 mt-2'>
                        <a href="https://www.facebook.com/esparsematrixsolutions/" target="_blank" rel="noreferrer">
                            <img src={fb} alt='Facebook' className='w-8 h-8 hover:scale-110 transition-transform' />
                        </a>
                        <a href="https://www.instagram.com/esparse_matrix_solutions/" target="_blank" rel="noreferrer">
                            <img src={ig} alt='Instagram' className='w-8 h-8 hover:scale-110 transition-transform' />
                        </a>
                        <a href="https://x.com/MatrixSparse" target="_blank" rel="noreferrer">
                            <img src={x} alt='Twitter' className='w-8 h-8 hover:scale-110 transition-transform' />
                        </a>
                        <a href="https://www.linkedin.com/company/sparse-matrix-solutions/" target="_blank" rel="noreferrer">
                            <img src={ln} alt='LinkedIn' className='w-8 h-8 hover:scale-110 transition-transform' />
                        </a>
                        <a href="https://www.youtube.com/channel/UCmmkB3zOe1d7g6FvXqtGcQw" target="_blank" rel="noreferrer">
                            <img src={yt} alt='YouTube' className='w-8 h-8 hover:scale-110 transition-transform' />
                        </a>
                    </div>
                </div>

                {/* Links Sections */}
                <div className='flex flex-col gap-3'>
                    <h3 className='text-xl font-semibold mb-2'>ABOUT</h3>
                    <ul className='flex flex-col gap-2'>
                        <li><Link to='/' className='hover:underline'>Home</Link></li>
                        <li><Link to='/aboutus' className='hover:underline'>About Us</Link></li>
                        <li><Link to='/career' className='hover:underline'>Career</Link></li>
                        <li><Link to='/blog' className='hover:underline'>Blog</Link></li>
                        <li><Link to='/contactus' className='hover:underline'>Contact Us</Link></li>
                    </ul>
                </div>

                <div className='flex flex-col gap-3'>
                    <h3 className='text-xl font-semibold mb-2'>POLICY</h3>
                    <ul className='flex flex-col gap-2'>
                        <li className='hover:underline cursor-pointer'>Terms of Services</li>
                        <li className='hover:underline cursor-pointer'>Privacy Policy</li>
                        <li className='hover:underline cursor-pointer'>Disclaimer</li>
                        <li className='hover:underline cursor-pointer'>Sitemap</li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div className='flex flex-col gap-3'>
                    <h3 className='text-xl font-semibold mb-2'>OFFICE ADDRESS</h3>
                    <ul className='flex flex-col gap-3 text-sm'>
                        <li className='flex items-start gap-2'>
                            <FaLocationDot className='mt-1 text-lg' />
                            <span>
                                133/1, Spectrum Building,<br />
                                Gurudwara Colony, Akurdi,<br />
                                Pune - 411033
                            </span>
                        </li>
                        <li className='flex items-center gap-2'>
                            <BsFillTelephoneFill className='text-base' />
                            <span>(+91) 8459694413</span>
                        </li>
                        <li className='flex items-center gap-2'>
                            <MdMail className='text-xl' />
                            <a href="mailto:info@sparsematrix.co.in" target="_blank" rel="noreferrer" className='hover:underline'>
                                info@sparsematrix.co.in
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Bottom Section */}
            <div className="mt-10 text-center text-sm text-gray-200 border-t border-gray-400 pt-4">
                © {new Date().getFullYear()} eSparse Matrix Solutions Pvt Ltd. All rights reserved.
            </div>
        </footer>
    )
}

export default Footer
